<template>
  <div class="login--panel col-xl-6 col-sm-12 display-flex flex-wrap">
    <section class="display-flex flex-wrap justify-content-center align-items-center w-100 pl-5 pr-5">
      <div class="d-block " style="margin: 0 auto">
        <div class="display-flex flex-wrap w-100 justify-content-center">
          <img src="../../assets/logo.png" style="margin-bottom: 20px">
          <section class="remindPassword--panel-header">
            <h2 style="letter-spacing: 4px">
              Vouchery Blue Diamond
            </h2>
            <div class="w-100 display-flex justify-content-center mt-3 mb-5">
              <h5 style="color: #bdbdbd; text-align: center">Wprowadź nowe hasło</h5>
            </div>
          </section>
          <form @submit.prevent="onResetPassword()" class="remindPassword--form">
            <fieldset class="w-100">
              <v-text-field
                v-validate="'required|min:8'"
                type="password"
                v-model="formData.password"
                data-vv-name="hasło"
                :error-messages="errors.collect('hasło')"
                browser-autocomplete="off"
                label="Hasło">
              </v-text-field>
            </fieldset>
            <fieldset class="w-100">
              <v-text-field
                v-validate="'required|min:8'"
                type="password"
                v-model="formData.password_confirmation"
                data-vv-name="powtórz hasło"
                :error-messages="errors.collect('powtórz hasło')"
                browser-autocomplete="off"
                label="Powtórz hasło">
              </v-text-field>
            </fieldset>
            <button type="submit"
                    id="remindPassword"
                    class="button--primary mt-4">
              Resetuj hasło
            </button>
            <div class="display-flex mt-4 w-100 justify-content-center">
              <router-link
                :to="'/login'"
                class="register--link">
                Zaloguj się
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'Remind-password',
    data() {
      return {
        formData: Object({}),
      };
    },
    methods: {
      ...mapActions('AuthStore', ['resetPassword']),
      onResetPassword() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.formData.token = this.$route.params.token;
              this.resetPassword(this.formData)
                .then(() => {
                  this.$router.push('/login');
                });
            }
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../styles/remindPassword";
</style>
